import { DoctorCreateRequestPayload } from "@/data/payload/admin/doctor-create-request-payload";
import { CreateDoctorReponseInfoEntity } from "@/domain/entity/admin/create-doctor-reponse-info-entity";
import { AdminRepository } from "@/domain/repository/admin-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class CreateDoctorUsecase {
  constructor(private readonly adminRepository: AdminRepository) {}

  async execute(
    name: string,
    hospitalCode: string,
    email: string,
    memo?: string,
  ): Promise<SATResult<CreateDoctorReponseInfoEntity, SATError>> {
    const createData: DoctorCreateRequestPayload = {
      fullName: name,
      email: email.toLowerCase(),
      hospitalCode: hospitalCode,
      memo: memo || "",
    };

    const result = await this.adminRepository.createDoctor(createData);
    if (result.isFailure) {
      console.log("[CreateDoctorUsecase] :: execute :: 의사 등록 실패", result.error);
      return SATResult.failure(result.error);
    }

    console.log("[CreateDoctorUsecase] :: execute :: 의사 등록 성공", result.value);
    return SATResult.success(result.value);
  }
}
